<div class="modal-container cart-delete-modal-container">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" [innerHtml]="'cart.deleteAllModal.title' | cxTranslate"></h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('Cross click')"
        [disabled]="deleteAllButtonClicked"
      >
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-info" [innerHtml]="'cart.deleteAllModal.modalInfo' | cxTranslate"></div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn secondary-btn cancel-btn mw-120"
        [innerHtml]="'cart.deleteAllModal.cancel' | cxTranslate"
        (click)="closeModal('Cross click')"
        [ngClass]="activeLanguage$ | async"
        [disabled]="deleteAllButtonClicked"
      ></button>
      <button
        type="button"
        class="btn primary-btn save-btn mw-120"
        (click)="deleteAllCart()"
        [ngClass]="activeLanguage$ | async"
        [class.rotating]="deleteAllButtonClicked"
        [disabled]="deleteAllButtonClicked"
      >
        @if (!deleteAllButtonClicked) {
        {{ 'cart.deleteAllModal.continue' | cxTranslate }}
        } @else { }
      </button>
    </div>
  </div>
</div>
